import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageDTO } from '../../models/message.model';
import { DatePipe, JsonPipe } from '@angular/common';
import { EmptyStateComponent } from '@pansa/ui';

@Component({
  selector: 'rqa-message-content',
  templateUrl: './message-content.component.html',
  styleUrl: './message-content.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DatePipe,
    EmptyStateComponent
  ]
})
export class MessageContentComponent {
    message = input<MessageDTO | null>(null);
}
